import { useQuery } from '@apollo/client';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import Input from 'layout/atoms/Input/Input';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import FormField from 'layout/molecules/FormField/FormField';
import FormSaveActions from 'layout/molecules/FormSaveActions/FormSaveActions';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { addCategory, selectCategoryById, updateCategory } from 'store/parameters/categoriesSlice';
import useCategoryValidation from './useCategoryValidation';
function CategoryEditor({ create = false }) {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const categoryId = (_a = useSelector(selectModalByName(create ? 'categoryCreator' : 'categoryEditor'))) === null || _a === void 0 ? void 0 : _a.id;
    const categoryDetails = useSelector((state) => selectCategoryById(state, categoryId || '')) || null;
    const { t } = useTranslation(['specification', 'common']);
    const { data: tenant } = useQuery(GET_CURRENT_TENANT);
    const tenantId = (_c = (_b = tenant === null || tenant === void 0 ? void 0 : tenant.me) === null || _b === void 0 ? void 0 : _b.currentTenant) === null || _c === void 0 ? void 0 : _c.id;
    const [formValues, setFormValues] = useState({
        name: '',
    });
    const { errors, isValid, pendingFields, markTouched, validateAll } = useCategoryValidation(formValues, t);
    useEffect(() => {
        if (!create && categoryDetails) {
            setFormValues({
                name: categoryDetails.name,
            });
        }
    }, [create, categoryDetails]);
    const handleFormChange = ({ target: { name, value }, }) => {
        setFormValues((values) => (Object.assign(Object.assign({}, values), { [name]: value })));
    };
    const handleCancel = () => {
        dispatch(closeModal({ name: create ? 'categoryCreator' : 'categoryEditor' }));
    };
    const handleFormSubmit = () => {
        if (!validateAll())
            return;
        if (create) {
            dispatch(addCategory({ tenantId, name: formValues.name }));
        }
        else {
            dispatch(updateCategory({ categoryId: categoryDetails.id, name: formValues.name }));
        }
        dispatch(closeModal({ name: create ? 'categoryCreator' : 'categoryEditor' }));
    };
    return (React.createElement(Modal, { name: create ? 'categoryCreator' : 'categoryEditor', size: "s", header: React.createElement(Label, { weight: "strong" }, create ? t('add_category') : t('edit_category')), footer: React.createElement(FormSaveActions, { isValid: isValid, isLoading: false, pendingFields: pendingFields, onSave: handleFormSubmit, onCancel: handleCancel, validateAll: validateAll }), onClose: handleCancel },
        React.createElement(FormField, { label: t('common:name'), error: errors.name },
            React.createElement(Input, { value: formValues === null || formValues === void 0 ? void 0 : formValues.name, onChange: handleFormChange, onBlur: () => markTouched('name'), name: "name", error: Boolean(errors.name), autoFocus: true }))));
}
export default memo(CategoryEditor);
